import { declareParams } from '@farfetched/core';
import { zodContract } from '@farfetched/zod';
import { createAuthQuery } from '../auth-http-client';
import { playerDetailsSchema } from '../types';

export const createGetPlayerDetailsQuery = () =>
	createAuthQuery({
		params: declareParams<number>(),
		request: {
			method: 'GET',
			url: (id) => `/player/details/${id}`,
		},
		response: {
			contract: zodContract(playerDetailsSchema),
		},
	});
